import { render, staticRenderFns } from "./task-analysis.vue?vue&type=template&id=15b07dca&scoped=true"
import script from "./task-analysis.vue?vue&type=script&lang=js"
export * from "./task-analysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b07dca",
  null
  
)

export default component.exports